<template>
  <div class="videocontent">
    <div class="videoList">
      <Row type="flex" v-if="pageTotal == 0" style="text-align: center;">
        <Col span="24"><img class="emptyImg" src="/static/images/empty.png" alt=""></Col>
        <Col span="24" style="margin-top:20px;">暂时没有相关内容～</Col>
      </Row>
      <Row :gutter="27" v-else v-for="(item,index) in packageList" :key="index" style="margin-bottom:15px;">
          <Col span="6" v-for="(n,m) in item" :key="m">
              <div class="microBox" @click="videoPlayer(n.videoid,n.name,0,n.showId)">
                  <div class="microImgBox">
                      <img class="microImg" :src="imgurl+ n.imgurl" alt="">
                  </div>
                  <div class="microMsg">
                      <div class="microTitle" :title="n.name">{{n.name}}</div>
                  </div>
              </div>
          </Col>
      </Row>
    </div>
    <div class="page" v-if="pageTotal !=0">
         <Page :total="pageTotal" :page-size="12" @on-change="changePage"/>
    </div>
  </div>

</template>

<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  export default {
    name: 'PrepareVideo',
    props:{
      prepareData: { //同步资源
        type: Object,
        defalut: null
      }
    },
    data() {
      return {
        pageTotal:null,
        urlHttp:'/testIp',
        packageList:null,
        imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
      }
    },
    watch: {
      prepareData: {
          handler: function(newVal,oldVal) {
            this.getSectionVideoList(1);
          },
          deep: true
        }
    },
    mounted() {
      const that = this;
      this.getSectionVideoList(1);
    },
    methods:{
      //获取视频列表
      getSectionVideoList(page){
        const that = this;
        const result = [];
        that.packageList = null;
        const url =  '/axt-resources/package_prepare/pageVideo';
        var params = {
            packageCourseId:that.prepareData.packageId,
            packageChapterId:that.prepareData.chapterId,
            packageLectureId:that.prepareData.lectureId,
            packageSectionId:that.prepareData.sectionId,
            useType: 0,
            orderBys: [{
            		direction: 'asc',
            		field: 'sort_id'
            }],
            showUseType: true,
            pageNo: page,
            pageSize: 12
        };
        //console.log(params)
        api.postFormAPI(url,params).then(res => {
          //数据处理
          console.log(res,"asdasdsadasd")
          that.pageTotal = res.data.data.total;                   //分页总数
          const packageList = res.data.data.rows;
          for(let i=0;i < packageList.length;i+=4){
              result.push(packageList.slice(i,i+4));
          }
          that.packageList = result;
         console.log('packageList',that.packageList)


        }).catch(err => {
          console.log(err)
        })
      },
      //翻页
      changePage(page){
          const that = this;
          this.getSectionVideoList(page);
      },
      //点击播放
      videoPlayer(videoId,name,sourse,id){
          this.$emit('showPlayer',true)
          console.log('videoId',videoId);
          const vidoeData = {
            videoId:videoId,
            name:name,
            sourse:sourse,
            id:id,
            packageSectionId:this.prepareData.sectionId
          }
          this.$nextTick(() => {
              bus.$emit('videoId',vidoeData)
          })

      }
    }
  }

</script>

<style>
  .emptyImg {
    width: 320px;
  }
  .videocontent {
    margin-top: 20px;
  }
  .microBox {
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
  }
  .microBox:hover .microImg{
      box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37);
  }
  .microBox:hover .microTitle{
      color:#3683FF;
  }
  .microImgBox{
      height:200px;
     /* display:table-cell;
      vertical-align: bottom; */
  }
  .microImg{
      width:100%;
      height: 100%;

  }
  .microImgHover{
      display: inline-block;
      border-radius: 10px;
  }
  /* @media screen and (min-width: 1024px) {
      .microImgBox {
         height:180px;
      }
  }
  @media screen and (min-width: 1100px) {
      .microImgBox {
         height:190px;
      }
  } */
  /* @media (min-width: 1280px) { html{font-size: 22px;} } */
  /* @media screen and (min-width: 1280px) {
       .microImgBox {
         height:200px;
      }
  }
  @media screen and (min-width: 1366px) {
      .microImgBox {
         height:200px;
      }
  }
  @media screen and (min-width: 1440px) {
      .microImgBox {
         height:200px;
      }
  }
  @media screen and (min-width: 1680px) {
      .microImgBox {
         height:210px;
      }
  }
  @media screen and (min-width: 1920px) {
      .microImgBox {
         height:220px;
      }
  } */
  .microMsg{
      /* margin-bottom: 10px; */
  }
  .microTitle{
      font-size: 16px;
      color: #34495E;
      font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/PrepareDetail/PrepareVideo.vue